// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QqF0","colBig":"styles_colBig__1DTVi","colSmall":"styles_colSmall__1S7jL","shopifyNameWrapper":"styles_shopifyNameWrapper__2sNRK"};